/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AssigneeId,
  EnrichmentRequest,
  MapDataFieldRefString,
  MapString,
  MeetingConfiguration,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "meetings-platform";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Returns meeting configuration (parts of meeting type with applied overrides and other settings)
   *
   * @name GetMeetingConfiguration
   * @request GET:/v1/public/tenant/{tenantId}/meeting/{meetingId}/config
   */
  getMeetingConfiguration = (tenantId: string, meetingId: string, params: RequestParams = {}) =>
    this.request<
      MeetingConfiguration,
      | AssigneeId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/public/tenant/${tenantId}/meeting/${meetingId}/config`,
      method: "GET",
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getMeetingConfiguration */
  getMeetingConfigurationPathGetter = (tenantId: string, meetingId: string) =>
    this.getServicePath(`/v1/public/tenant/${tenantId}/meeting/${meetingId}/config`);

  /**
   * @description Returns a list of known values depending on configured mappings
   *
   * @name FindGuestDataAmongAllKnownSources
   * @request PUT:/v1/tenant/{tenantId}/find-enrichment-data
   * @secure
   */
  findGuestDataAmongAllKnownSources = (tenantId: string, data: EnrichmentRequest, params: RequestParams = {}) =>
    this.request<
      MapDataFieldRefString,
      | AssigneeId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/find-enrichment-data`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findGuestDataAmongAllKnownSources */
  findGuestDataAmongAllKnownSourcesPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/find-enrichment-data`);
}
